<template>
  <div id="app">
    <v-app>

      <v-fade-transition mode="out-in">
        <component :is="getDynamicComponent()"/>
      </v-fade-transition>

      <!-- snackbar -->
      <v-snackbar v-model="snackbar" :color="alert.type" :timeout="timeout" bottom left>{{alert.message}}</v-snackbar>
      <!-- ./ snackbar -->

    </v-app>
  </div>
</template>

<script>


  import AppContainer from './views/AppContainer.vue';
  import AuthContainer from '@imemento/spa-helpers/src/views/auth/AuthContainer.vue';
  import Healthy from '@imemento/spa-helpers/src/views/healthy/Healthy.vue';

  import { mapActions, mapGetters } from 'vuex'

  import storage from './storage';

  export default {
    components: {
      'im-healthy-container': Healthy,
      'im-app-container': AppContainer,
      'im-auth-container': AuthContainer,
    },

    // this will make sure view app is refreshed
    // if the user logged-in/logged-out on another spa
    mounted() {
      window.onfocus = async () => {
        let token = await storage.getToken();
        let roles = await storage.getRoles();

        if ((!token && !roles) && this.$route.meta.private_route) {
          this.$router.push('/authentication/login')
        }

        if ((token && roles) && !this.$route.meta.private_route) {
          this.$router.push('/')
        }

      };
    },

    data() {
      return {
        snackbar: false,
        timeout: 2500
      }
    },

    watch: {
      snackbar: {
        handler: function (snackbar) {
          if (snackbar === false) {
            this.clear()
          }
        },
        deep: true
      },
      alert: {
        handler: function (alert) {
          this.snackbar = (alert.visible === true)
        },
        deep: true
      }
    },

    computed: {
      ...mapGetters('alert', ['alert'])
    },

    methods: {
      ...mapActions('alert', ['clear']),

      getDynamicComponent() {
        if (this.$route.path === '/healthy')
          return 'im-healthy-container';

        if (this.$route.meta.private_route === false)
          return 'im-auth-container';

        if (this.$route.meta.private_route === true)
          return 'im-app-container';

        if (this.$route.meta.private_route === undefined)
          return '';
      }

    }
  }
</script>

<style>
  @media only screen and (max-width: 500px) {
    #app .v-toolbar__content .v-toolbar__title:not(:first-child) {
      margin-left: 0px !important;
    }

    #app .im-btn-lng .v-btn {
      min-width: 36px;
    }

    #app .im-btn-lng .v-btn__content span,
    #app .im-btn-lng .v-btn__content .mx-1 {
      display: none;
    }

    #app .im-btn-lng .v-btn__content .v-avatar {
      height: 32px !important;
      width: 32px !important;
    }

    #app .im-btn-lng .v-btn {
      padding: 0px !important;
      margin: 0px !important;
    }
  }

  @media only screen and (max-width: 600px) {
    .title-filter {
      font-size: 10px;
      font-weight: 700;
      color: #555;
    }

    .v-card__actions .im-select {
      font-size: 12px !important;
    }

    .im-select .v-icon {
      font-size: 12px;
    }
  }
</style>
